// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-features-NotFound-style__error--Yoao7{position:fixed;top:0;bottom:0;width:calc(100vw - 160px);height:200px;margin:auto}@media screen and (max-width: 1591px){.src-features-NotFound-style__error--Yoao7{width:calc(100vw - 56px)}}.src-features-NotFound-style__title--maeQR{margin-bottom:32px;text-align:center}.src-features-NotFound-style__content--iqZiA{text-align:center}.src-features-NotFound-style__content--iqZiA p{margin:3px 0}.src-features-NotFound-style__btn--YEE6w{width:100%;margin-top:25px;text-align:center}.src-features-NotFound-style__button--v47ah{width:240px}`, "",{"version":3,"sources":["webpack://./src/features/NotFound/style.scss"],"names":[],"mappings":"AACA,2CACE,cAAA,CACA,KAAA,CACA,QAAA,CACA,yBAAA,CACA,YAAA,CACA,WAAA,CAGF,sCACE,2CACE,wBAAA,CAAA,CAIJ,2CACE,kBAAA,CACA,iBAAA,CAGF,6CACE,iBAAA,CAEA,+CACE,YAAA,CAIJ,yCACE,UAAA,CACA,eAAA,CACA,iBAAA,CAGF,4CACE,WAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.error {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: calc(100vw - 160px);\n  height: 200px;\n  margin: auto;\n}\n\n@media screen and (max-width: $lGnShrinkWindowWidth) {\n  .error {\n    width: calc(100vw - 56px);\n  }\n}\n\n.title {\n  margin-bottom: 32px;\n  text-align: center;\n}\n\n.content {\n  text-align: center;\n\n  p {\n    margin: 3px 0;\n  }\n}\n\n.btn {\n  width: 100%;\n  margin-top: 25px;\n  text-align: center;\n}\n\n.button {\n  width: 240px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": `56px`,
	"lCompanyHeight": `114px`,
	"h2FontSize": `28px`,
	"h3FontSize": `20px`,
	"bodyLineHeight": `20px`,
	"lGnShrinkWindowWidth": `1591px`,
	"tableVerticalPadding": `8px`,
	"tableHorizontalPadding": `16px`,
	"lPersonnelBreakWidth": `1599px`,
	"cNavigationAccent": `#f57f17`,
	"cTableBodyOdd": `#fff`,
	"cTableBodyEven": `#f2f6f8`,
	"cTableHover": `#c5ddeb`,
	"cTableHeadOdd": `#eaf1f5`,
	"cTableHeadEven": `#dee8ef`,
	"zPageLoading": `2`,
	"error": `src-features-NotFound-style__error--Yoao7`,
	"title": `src-features-NotFound-style__title--maeQR`,
	"content": `src-features-NotFound-style__content--iqZiA`,
	"btn": `src-features-NotFound-style__btn--YEE6w`,
	"button": `src-features-NotFound-style__button--v47ah`
};
export default ___CSS_LOADER_EXPORT___;
